import { render, staticRenderFns } from "./NewExpenseAddForSelfService.vue?vue&type=template&id=96606e64"
import script from "./NewExpenseAddForSelfService.vue?vue&type=script&lang=js"
export * from "./NewExpenseAddForSelfService.vue?vue&type=script&lang=js"
import style0 from "./NewExpenseAddForSelfService.vue?vue&type=style&index=0&id=96606e64&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports